import styled from "styled-components"

export const Wrapper = styled.div`
  padding: 80px 40px;
  background: ${(props) => props.theme.bgSectorColor};

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: relative;
  .map-background {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
  @media (max-width: 600px) {
    padding: 40px 20px;
  }
  @media (min-width: 601px) and (max-width: 1023px) {
    padding: 50px 60px;
  }
`

export const MapCardWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px;
  @media (max-width: 850px) {
    flex-direction: column;
    gap: 12px;
  }
  @media (min-width: 601px) and (max-width: 1023px) {
    gap: 20px;
  }
`
